import { createFileRoute } from '@tanstack/react-router';

import { ProjectDetail } from '@/features/projects/ProjectDetail';

export const Route = createFileRoute('/_authenticated/projects/$projectSlug/')({
  component: function Page() {
    const { projectSlug } = Route.useParams();
    return <ProjectDetail projectSlug={projectSlug} />;
  },
});
